import React from 'react';
import LocationTemplate from './LocationTemplate';

const RichlandsPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Richlands"
      stateName="North Carolina"
      countyName="Onslow"
      zipCodes={["28574"]}
      latitude={34.8985}
      longitude={-77.5469}
      population={1845}
      historicalFact="Named for the fertile agricultural land in the area; incorporated in 1880."
      nearbyTowns={[
        "Jacksonville, NC",
        "Maysville, NC",
        "Trenton, NC",
        "Beulaville, NC",
        "Pink Hill, NC",
        "Kinston, NC",
        "Swansboro, NC",
        "Sneads Ferry, NC"
      ]}
    />
  );
};

export default RichlandsPage;